// @flow

import bafwasendekisangani from '../../../static/bafwasendekisangani.json'
import benimambasa from '../../../static/benimambasa.json'
import kampalakasese from '../../../static/kampalakasese.json'
import mambasabafwasende from '../../../static/mambasabafwasende.json'
import kasesebeni from '../../../static/kasesebeni.json'

export type Chapter = {
  title: string,
  text: string,
  fallbackPicture: {
    horizontalId: string,
    verticalId: string
  },
  mapbox: any
}

export const chapters: Array<Chapter> = [
  {
    title: 'Reisen inn i Kongo',
    text: 'Tjostolv Moland og Joshua French kjørte over 1.000 kilometer fra Kampala i Uganda til Kisangani i Kongo. Den østlige delen av Kongo hadde vært urolig i flere år. <br><br>Landet var på randen av borgerkrig og hundre tusen mennesker var på flukt. FN-soldater ble jaget av lokale militsgrupper.',
    fallbackPicture: '1.13936809',
    mapbox: {
      id: 'kampala',
      duration: 6000,
      center: [32.573023, 0.3135714],
      bounds: [[-8.8984375, -32.39851580247401], [56.40625, 36.31512514748051]
      ],
      zoom: 2,
      pitch: 40,
      bearing: 0,
      point: { name: 'kampala', lat: 0.3135714, lon: 32.573023 }
    }
  }, {
    title: ' ',
    text: '<b>28. april: </b>Moland og French kjører sammen på en motorsykkel fra Kampala via Fort Portal og sørover mot Kasese. De overnatter på en lodge der. Tidligere har de forklart at de var på vei til Kisangani for å se seg omkring. En guttetur ble det kalt den gangen. <br><br><strong>– Vi var absolutt ikke på noen guttetur. Vi var der på vegne av noen. Vi skulle løse et lite oppdrag, før vi skulle reise ut av landet igjen. Det var formålet med hele turen, sier French nå.</strong> ',
    image: 'https://nrk.no/serum/api/imagecrop/1.13912971?cropid=f169w600',
    fallbackPicture: '1.13936813',
    mapbox: {
      id: 'kasese',
      duration: 6000,
      center: [30.0667859, 0.1755904],
      bearing: 10,
      zoom: 8,
      pitch: 0,
      point: { name: 'kasese', lat: 0.1755904, lon: 30.0667859 },
      line: { name: 'kampalakasese', data: kampalakasese }
    }
  }, {
    title: '',
    text: '<b>29. april: </b>De to skulle møte noen i Kongo og French forklarer at de ikke kunne fly fordi de hadde med seg ting de skulle levere. Han vil ikke si hva slags saker det var. Det er på det rene at at de hadde med våpen inn i Kongo:<br><br> <strong>– Ja, vi hadde jo med hagla vår, den registrerte vi på grensa. Og så hadde vi med litt penger og andre ting. Oppdraget vi skulle løse var «low risk», vi trodde dette skulle gå temmelig greit, forteller French. </strong><br><br>Første natt i Kongo overnatter de i et telt i jungelen utenfor en landsby noen kilometer nord-vest for Beni. ',
    fallbackPicture: '1.13936819',
    mapbox: {
      id: 'beni',
      duration: 6000,
      bearing: 0,
      center: [29.4264502, 0.488113],
      zoom: 8,
      speed: 0.6,
      pitch: 0,
      point: { name: 'beni', lat: 0.488113, lon: 29.4264502 },
      line: { name: 'kasesebeni', data: kasesebeni }
    }
  },
  {
    title: '',
    text: '<b>30. april: </b>Kjører videre mot Mambasa. French forteller at noen forsøkte å rane dem på veien. Det regnet mye og veiene var våte og dårlige. Overnattingen skjer på Hotel Pacifique i Mambasa.  ',
    fallbackPicture: '1.13936822',
    mapbox: {
      id: 'mambasa',
      duration: 6000,
      bearing: 0,
      center: [29.029941, 1.3554324],
      zoom: 8,
      pitch: 0,
      speed: 0.5,
      point: { name: 'mambasa', lat: 1.3554324, lon: 29.029941 },
      line: { name: 'benimambasa', data: benimambasa }
    }
  }, {
    title: '',
    text: '<b>1. mai: </b>De hilser på parkvaktene i Epulu, før de kjører videre til Bafwasende og spiser. På kvelden telter de litt sør for landsbyen.',
    fallbackPicture: '1.13936825',
    mapbox: {
      id: 'Bafwasende',
      duration: 6000,
      bearing: -5,
      center: [27.153957, 1.0032544],
      zoom: 7,
      point: { name: 'bafwasende', lat: 1.0032544, lon: 27.153957 },
      line: { name: 'mambasabafwasende', data: mambasabafwasende }
    }
  }, {
    title: '',
    text: '<b>2. mai: </b>De har hatt problemer med motorsykkelen hele veien, men kommer seg til slutt fram og dytter den inn foran Hotel Rivieria i Kisangani. ',
    fallbackPicture: '1.13936829',
    mapbox: {
      id: 'kisangani',
      duration: 6000,
      bearing: 10,
      center: [25.193249, 0.5129774],
      zoom: 7,
      pitch: 0,
      point: { name: 'kisangani', lat: 0.514009, lon: 25.187081 },
      line: { name: 'bafwasendekisangani', data: bafwasendekisangani }
    }
  }, {
    title: '',
    text: '<b>3. og 4. mai: </b>Joshua French sier de brukte dagene i Kisangani på oppdrag og at de skulle møte noen, men at møtet ikke ble noe av. Siden motorsykkelen var ødelagt, leide de en bil med sjåfør som skulle kjøre dem tilbake mot Uganda igjen. ',
    fallbackPicture: '1.13936829',
    mapbox: {
      id: 'mote',
      duration: 6000,
      bearing: 20,
      center: [25.193249, 0.5129774],
      zoom: 7,
      pitch: 0,
      point: { name: 'drept', lat: 0.514009, lon: 25.187081 }
    }
  }, {
    title: '',
    text: '<b>5. mai: </b>Sjåfør Abedi Kasongo, sammen med Kasimu Aradjabu og Kepo Ailo, kjører Moland og French. De drar fra Kisangani ved 18-tiden og stanser 109 kilometer øst for Kisangani. I kanten av den røde jordveien i jungelen blir Kasongo drept.  ',
    image: 'https://nrk.no/serum/api/imagecrop/1.13924355?cropid=f169w600',
    fallbackPicture: '1.13936832',
    mapbox: {
      id: 'drapet',
      duration: 6000,
      bearing: 20,
      center: [26.008988, 0.609227],
      zoom: 7,
      pitch: 0,
      point: { name: 'skutt', lat: 0.609227, lon: 26.008988 }
    }
  }, {
    title: '',
    text: '<b>6. mai: </b>Moland og French rømmer med Kasongos bil. De kommer til Epulu naturpark ved tre-tiden på natten og slår leir noen kilometer unna parkvaktene. På morgenen kjører de igjen mot parken, men snur på grunn av en veisperring. De blir tatt igjen i en landsby, men kommer seg unna og inn i jungelen. Om natten slår de leir i skogen. ',
    fallbackPicture: '1.13936839',
    mapbox: {
      id: 'epulu',
      duration: 6000,
      bearing: 0,
      center: [28.556685, 1.400884],
      zoom: 7,
      pitch: 0,
      point: { name: 'Epulu', lat: 1.400884, lon: 28.556685 }
    }
  }, {
    title: '',
    text: '<b>7. - 8. mai: </b> Nå går de østover i jungelen, ca to mil sør for veien, sier French. Det er tett jungel og på det verste bruker de én time på å bevege seg 500 meter. Det er ingen dyr eller mat der, kun fugler, men de klarer de ikke å fange.',
    fallbackPicture: '1.13936840',
    mapbox: {
      id: 'flukten',
      duration: 6000,
      bearing: 0,
      center: [28.580349, 1.211269],
      zoom: 10,
      pitch: 0,
      point: { name: 'På flukt i skogen', lat: 1.211269, lon: 28.580349 }
    }
  }, {
    title: '',
    text: '<b>9. mai: </b>Ved firetiden om morgenen kommer de til en landsby der det er noen soldater. Moland løper unna, mens French kaster seg ned i en grøft. Joshua French blir arrestert. ',
    fallbackPicture: '1.13936920',
    mapbox: {
      id: 'soldater',
      duration: 6000,
      bearing: 25,
      center: [28.684052, 1.408386],
      zoom: 10,
      pitch: 0,
      point: { name: 'Soldater', lat: 1.408386, lon: 28.684052 }
    }
  }, {
    title: '',
    text: '<b>10. mai: </b>Tjostolv Moland fortsetter flukten på nordsiden av veien, der det er høyere terreng og lettere å gå, men vanskeligere å finne vann. Han ringer hjem og blir rådet til å overgi seg. Først holder han seg et stykke unna veien og følger stier inne i jungelen, men begynner etter hvert å bevege seg langs veien i korte perioder. ',
    fallbackPicture: '1.13936874',
    mapbox: {
      id: 'ringerhjem',
      duration: 6000,
      bearing: 22,
      center: [28.759554, 1.420746],
      zoom: 9,
      pitch: 0,
      point: { name: 'Moland alene', lat: 1.420746, lon: 28.759554 }
    }
  }, {
    title: '',
    text: '<b>11. mai: </b>Moland melder seg for politiet i Mambasa. Nå er både han og French arrestert. De er mistenkt for drap og spionasje. ',
    fallbackPicture: '1.13936873',
    mapbox: {
      id: 'melderseg',
      duration: 6000,
      bearing: 30,
      center: [29.029941, 1.3554324],
      zoom: 7,
      pitch: 50,
      speed: 0.5,
      point: { name: 'mambasa', lat: 1.3554324, lon: 29.029941 }
    }
  }
]



// WEBPACK FOOTER //
// ./src/v1/components/chapters.js